<template>
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top " id="mainNav">
      <div class="container">
        <RouterLink class="navbar-brand" to="/#page-top">
          <img src="/src/assets/img/logo-pinhatas-may.svg" width="32" height="31" class=""
            alt="logo-pinhatas-may" id="logo" />
            <img src="/src/assets/img/Pinhatas-may-logo-resized.webp" width="136" height="22"
            alt="Piñatas May" class="img-fluid"/></RouterLink>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive"
          aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          Menú
          <i class="fas fa-bars ms-1"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav text-uppercase ms-auto py-4 py-lg-0">
            <li class="nav-item">
              <RouterLink class="nav-link" title="Servicios para Fiestas" to="/#services">Servicios</RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink class="nav-link" to="/#portfolio" title="Catálogo de Piñatas">Catálogo</RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink class="nav-link" to="/#about" title="Sobre Piñatas May">Nosotros</RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink class="nav-link" to="/#call" title="Reserva Elaboración de Piñatas">Reserva</RouterLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</template>
<script setup>
import { onMounted } from 'vue';
import { RouterLink } from 'vue-router';
import * as bootstrap from 'bootstrap'
onMounted(() => {
  
// Navbar shrink function
  var navbarShrink = function () {
      const navbarCollapsible = document.body.querySelector('#mainNav');
      if (!navbarCollapsible) {
          return;
      }
      if (window.scrollY === 0) {
          navbarCollapsible.classList.remove('navbar-shrink')
          logo.classList.remove('fa-shake')
      } else {
          navbarCollapsible.classList.add('navbar-shrink')
          logo.classList.add('fa-shake')
      }

  };

  // Shrink the navbar 
  setTimeout(navbarShrink, 300);
  // navbarShrink();

  // Shrink the navbar when page is scrolled
  document.addEventListener('scroll', navbarShrink);

  //  Activate Bootstrap scrollspy on the main nav element
  const mainNav = document.body.querySelector('#mainNav');
  if (mainNav) {
      new bootstrap.ScrollSpy(document.body, {
          target: '#mainNav',
          rootMargin: '0px 0px -40%',
      });
  };

  // Collapse responsive navbar when toggler is visible
  const navbarToggler = document.body.querySelector('.navbar-toggler');
  const responsiveNavItems = [].slice.call(
      document.querySelectorAll('#navbarResponsive .nav-link')
  );
  responsiveNavItems.map(function (responsiveNavItem) {
      responsiveNavItem.addEventListener('click', () => {
          if (window.getComputedStyle(navbarToggler).display !== 'none') {
              navbarToggler.click();
          }
      });
  });
});
</script>